export default {
  formFields: {
    fieldHelp: 'Klicken für Beschreibung',
    defaultAbbreviation: 'Sw.: ',
    paramJSONContent: 'JSON Inhalt',
    wrongInputValue: 'Fehlerhafter Wert für diesen Parameter.',
    notValidJsonString: 'Ungültiges JSON Objekt in :fieldName',
  }
}
